import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { concatAll, map, switchMap, take, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class MunicipiosRecuperarService {
  /**
   * @description constructor
   * @params http
   */
  constructor(
    private http: HttpClient
  ) {
    this.http = http;
  }
  /**
   * @description recuperar municipio
   * @params code
   */
  getMunicipality(code: number): Observable<Array<any>> {
    const headerConfig: any = {
      headers: new HttpHeaders()
        .append('Content-Type', 'application/x-www-form-urlencoded')
    };

    return this.http.get(
      environment.endpoints.urlBase +
      environment.endpoints.municipiosRecuperar.name + `${code}`,
      headerConfig
    ).pipe(
      map((response: any) => {
        return response.map((element: any) => ({
            Id_Municipio: element.idMunicipio,
            Des_Municipio: element.desMunicipio,
            Id_Provincia: element.idProvincia,
            Des_Provincia: element.desProvincia,
            Id_Error : element.idError,
            Des_Error: element.desError
        }));
      }),
    );
  }
  /**
   * @description recuperar municipio no español
   * @params idCountry
   */
  getMunicipalityNoSpain(idCountry: number): Observable<object> {
    const headerConfig: any = {
      headers: new HttpHeaders()
        .append('Content-Type', 'application/x-www-form-urlencoded')
        .append('Access-Control-Allow-Origin', '*')
    };
    headerConfig.params = new HttpParams({ fromObject: { idPais: idCountry.toString() } });
    return this.http.get(
      environment.endpoints.urlBase +
      environment.endpoints.municipiosNoEspañaRecuperar.name,
      headerConfig
    ).pipe(
      map((response: any) => {
        return response.map((element: any) => ({
            Id_Municipio: element.idMunicipio,
            Des_Municipio: element.desMunicipio,
            Id_Provincia: element.idProvincia,
            Des_Provincia: element.desProvincia,
            Id_Error : element.idError,
            Des_Error: element.desError
        }));
      }),
    );
  }
}
